import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  ClosingSideDrawerComponent,
  SideDrawerContentDirective,
  SideDrawerFooterDirective,
  SideDrawerPreTitleActionsDirective,
  SideDrawerTitleActionsDirective,
} from './closing-side-drawer/closing-side-drawer.component';
import { WordpressContentComponent } from './wordpress-content/wordpress-content.component';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ClosingSideDrawerComponent,
    SideDrawerContentDirective,
    SideDrawerFooterDirective,
    SideDrawerTitleActionsDirective,
    SideDrawerPreTitleActionsDirective,
    WordpressContentComponent,
  ],
  imports: [CommonModule, MatToolbarModule, MatIconModule, MatButtonModule, TranslateModule],
  exports: [
    ClosingSideDrawerComponent,
    SideDrawerContentDirective,
    SideDrawerFooterDirective,
    SideDrawerTitleActionsDirective,
    SideDrawerPreTitleActionsDirective,
    WordpressContentComponent,
  ],
})
export class SideDrawerModule {}
